export enum DOSAGE_FREQUENCIES_ENUM {
  EVERY_1_MONTH = 'Every Month',
  EVERY_2_MONTHS = 'Every 2 Months',
  EVERY_3_MONTHS = 'Every 3 Months'
}
